export var SECTION_ENUM;
(function (SECTION_ENUM) {
    SECTION_ENUM["PERFORMANCE"] = "performance";
    SECTION_ENUM["STAFFING"] = "staffing";
})(SECTION_ENUM || (SECTION_ENUM = {}));
export var METRICS_ENUM;
(function (METRICS_ENUM) {
    METRICS_ENUM["SERVICE_LEVEL"] = "serviceLevel";
    METRICS_ENUM["ASA"] = "asa";
    METRICS_ENUM["OCCUPANCY"] = "occupancy";
    METRICS_ENUM["AHT"] = "aht";
    METRICS_ENUM["CONCURRENCY"] = "concurrency";
    METRICS_ENUM["WORK_OFFERED_HANDLED"] = "workOffered";
    METRICS_ENUM["PRODUCTION_HOURS"] = "productionHours";
    METRICS_ENUM["WORKLOAD_HOURS"] = "workloadHours";
    METRICS_ENUM["REQUIRED_FTE"] = "requiredFte";
    METRICS_ENUM["PRODUCTIVE_FTE"] = "productiveFte";
    METRICS_ENUM["REQUIRED_HEADCOUNT"] = "requiredHeadcount";
    METRICS_ENUM["ATTRITION"] = "attrition";
    METRICS_ENUM["ABANDONMENT_RATE"] = "abandonmentRate";
})(METRICS_ENUM || (METRICS_ENUM = {}));
export var FREQUENCY_ENUM;
(function (FREQUENCY_ENUM) {
    FREQUENCY_ENUM["DAILY"] = "daily";
    FREQUENCY_ENUM["PERIOD"] = "period";
})(FREQUENCY_ENUM || (FREQUENCY_ENUM = {}));
export var PERIOD_KEY;
(function (PERIOD_KEY) {
    PERIOD_KEY["START"] = "periodStart";
    PERIOD_KEY["END"] = "periodEnd";
})(PERIOD_KEY || (PERIOD_KEY = {}));
export var SUMMARY_KEYS;
(function (SUMMARY_KEYS) {
    SUMMARY_KEYS["PLANNED"] = "planned";
    SUMMARY_KEYS["ACTUAL"] = "actual";
    SUMMARY_KEYS["VARIANCE"] = "variance";
    SUMMARY_KEYS["THRESHOLD"] = "threshold";
    SUMMARY_KEYS["HANDLED"] = "handled";
    SUMMARY_KEYS["ABANDONMENT_RATE"] = "abandonmentRate";
})(SUMMARY_KEYS || (SUMMARY_KEYS = {}));
export var SETTING_KEYS;
(function (SETTING_KEYS) {
    SETTING_KEYS["SERVICE_LEVEL"] = "serviceLevel";
    SETTING_KEYS["ASA"] = "asa";
    SETTING_KEYS["OCCUPANCY"] = "occupancy";
    SETTING_KEYS["AHT"] = "aht";
    SETTING_KEYS["CONCURRENCY"] = "concurrency";
    SETTING_KEYS["WORK_OFFERED"] = "workOffered";
    SETTING_KEYS["ABANDONMENT_RATE"] = "abandonmentRate";
    SETTING_KEYS["PRODUCTION_HOURS"] = "productionHours";
    SETTING_KEYS["WORKLOAD_HOURS"] = "workloadHours";
    SETTING_KEYS["REQUIRED_FTE"] = "requiredFte";
    SETTING_KEYS["PRODUCTIVE_FTE"] = "productiveFte";
    SETTING_KEYS["REQUIRED_HEADCOUNT"] = "requiredHeadcount";
    SETTING_KEYS["ATTRITION"] = "attrition";
})(SETTING_KEYS || (SETTING_KEYS = {}));
export var RANGE_COLORS;
(function (RANGE_COLORS) {
    RANGE_COLORS["ACCEPTABLE"] = "acceptable";
    RANGE_COLORS["CAUTION"] = "caution";
    RANGE_COLORS["OUTSIDE"] = "outside";
})(RANGE_COLORS || (RANGE_COLORS = {}));
export var DAILY_FILTER_KEYS;
(function (DAILY_FILTER_KEYS) {
    DAILY_FILTER_KEYS["DAILY_AVERAGE"] = "average";
    DAILY_FILTER_KEYS["SPECIFIC_DAY"] = "specific";
})(DAILY_FILTER_KEYS || (DAILY_FILTER_KEYS = {}));
export var ACTUAL_DATA_FIELDS;
(function (ACTUAL_DATA_FIELDS) {
    ACTUAL_DATA_FIELDS["ACTUAL_DATA"] = "actualData";
    ACTUAL_DATA_FIELDS["AVERAGE"] = "average";
    ACTUAL_DATA_FIELDS["UPSERT_DATASET"] = "upsert_dataset";
})(ACTUAL_DATA_FIELDS || (ACTUAL_DATA_FIELDS = {}));
export var DAILY_DATA_FIELDS;
(function (DAILY_DATA_FIELDS) {
    DAILY_DATA_FIELDS["DATE"] = "date";
    DAILY_DATA_FIELDS["DAY"] = "day";
    DAILY_DATA_FIELDS["INTERVAL"] = "interval";
    DAILY_DATA_FIELDS["PLAN"] = "planned";
    DAILY_DATA_FIELDS["ACTUAL"] = "actual";
    DAILY_DATA_FIELDS["VARIANCE"] = "variance";
    DAILY_DATA_FIELDS["PLAN_OFFERED"] = "planOffered";
    DAILY_DATA_FIELDS["ACTUAL_OFFERED"] = "actualOffered";
    DAILY_DATA_FIELDS["ACTUAL_HANDLED"] = "actualHandled";
    DAILY_DATA_FIELDS["VARIANCE_OFFERED"] = "varianceOffered";
    DAILY_DATA_FIELDS["ABANDONMENT_RATE"] = "abandonmentRate";
})(DAILY_DATA_FIELDS || (DAILY_DATA_FIELDS = {}));
export var CHART_KEYS;
(function (CHART_KEYS) {
    CHART_KEYS["PLAN"] = "planned";
    CHART_KEYS["ACTUAL"] = "actual";
    CHART_KEYS["VARIANCE"] = "variance";
    CHART_KEYS["OFFERED"] = "offered";
    CHART_KEYS["HANDLED"] = "handled";
    CHART_KEYS["ABANDONMENT_RATE"] = "abandonmentRate";
})(CHART_KEYS || (CHART_KEYS = {}));
export var PERIOD_DATA_FIELDS;
(function (PERIOD_DATA_FIELDS) {
    PERIOD_DATA_FIELDS["SERVICE_LEVEL"] = "serviceLevel";
    PERIOD_DATA_FIELDS["ASA"] = "asa";
    PERIOD_DATA_FIELDS["OCCUPANCY"] = "occupancy";
    PERIOD_DATA_FIELDS["AHT"] = "aht";
    PERIOD_DATA_FIELDS["CONCURRENCY"] = "concurrency";
    PERIOD_DATA_FIELDS["WORK_OFFERED"] = "workOffered";
    PERIOD_DATA_FIELDS["PRODUCTION_HOURS"] = "productionHours";
    PERIOD_DATA_FIELDS["WORKLOAD_HOURS"] = "workloadHours";
    PERIOD_DATA_FIELDS["REQUIRED_FTE"] = "requiredFte";
    PERIOD_DATA_FIELDS["PRODUCTIVE_FTE"] = "productiveFte";
    PERIOD_DATA_FIELDS["REQUIRED_HEADCOUNT"] = "requiredHeadcount";
    PERIOD_DATA_FIELDS["ATTRITION"] = "attrition";
    PERIOD_DATA_FIELDS["PLAN"] = "planned";
    PERIOD_DATA_FIELDS["ACTUAL"] = "actual";
    PERIOD_DATA_FIELDS["VARIANCE"] = "variance";
    PERIOD_DATA_FIELDS["OFFERED"] = "offered";
    PERIOD_DATA_FIELDS["HANDLED"] = "handled";
    PERIOD_DATA_FIELDS["ABANDONMENT_RATE"] = "abandonmentRate";
    PERIOD_DATA_FIELDS["WORK_OFFERED_HANDLED"] = "workOfferedHandled";
})(PERIOD_DATA_FIELDS || (PERIOD_DATA_FIELDS = {}));
export var INTERVAL_TYPE;
(function (INTERVAL_TYPE) {
    INTERVAL_TYPE["FIFTEEN_MINUTES"] = "PT15M";
    INTERVAL_TYPE["THIRTY_MINUTES"] = "PT30M";
    INTERVAL_TYPE["SIXTY_MINUTES"] = "PT60M";
    INTERVAL_TYPE["DAILY"] = "P1D";
    INTERVAL_TYPE["WEEKLY"] = "P1W";
    INTERVAL_TYPE["MONTHLY"] = "P1M";
})(INTERVAL_TYPE || (INTERVAL_TYPE = {}));
export var ACTUAL_ATTRITION_MODE;
(function (ACTUAL_ATTRITION_MODE) {
    ACTUAL_ATTRITION_MODE["PERCENTAGE"] = "percentage";
    ACTUAL_ATTRITION_MODE["ABSOLUTE"] = "absolute";
})(ACTUAL_ATTRITION_MODE || (ACTUAL_ATTRITION_MODE = {}));
